import { useAcl } from '@/hooks/useAcl';
import { RootState } from '@/store/store';

import React from 'react';
import { useSelector } from 'react-redux';
import { Navigate } from 'react-router';

import { SpinnerLoading } from '@sobrus-com/sobrus-design-system-v2';

type PrivateRouteProps = {
	component: React.ReactNode;
	canDoes: string[];
};

export const PrivateRoute = ({ component, canDoes }: PrivateRouteProps) => {
	const { canAll } = useAcl();
	const isLogin = useSelector((state: RootState) => state.user.isLogin);
	const isFetching = useSelector((state: RootState) => state.user.isFetching);
	const isAuthenticatedUser = useSelector((state: RootState) => state.user.isAuthenticatedUser);

	if (!isFetching && isAuthenticatedUser) {
		if (isLogin) {
			if (canAll(canDoes) || !canDoes) {
				return component; // If the component is already JSX, render it directly
			} else {
				return <Navigate to="/denied_access" />;
			}
		} else {
			return <Navigate to="/signin" />;
		}
	} else if (!isAuthenticatedUser) {
		return <Navigate to="/signin" />;
	} else return <Loader />;
};

const Loader = () => (
	<div className="sns">
		<div className="loader">
			<SpinnerLoading loading />
		</div>
	</div>
);
